import { AuthService } from '../auth/auth.service';

import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { environment } from '../../environments/environment';

import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LogbookService {
  private http = inject(HttpClient);
  private auth = inject(AuthService);

  public fetchCustomerLogbook(start: string, end: string): Observable<any> {
    const customerId = this.auth.getCustomerDocument()['customerId'];
    const url = environment.url.bffV3 + '/customer/' + customerId + '/logbook';
    const fullUrl = url + '?dtgStart=' + start + '&dtgEnd=' + end;
    return this.http.get(fullUrl);
  }
}
